import React from 'react'
import "./sharepost.css"
import Topbar from '../../components/topbar/Topbar'
import Bottom from '../../components/Bottom/Bottom'
import { useContext, useRef, useState, useEffect } from "react";
import axiosInstance from '../../config';
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import SocialContext from "../../context/SocialContext";
import CollectionsIcon from '@mui/icons-material/Collections';
import Alertjs from '../../components/alert/Alert';
import Progress from '../../components/Progress/Progress'
import { PermMedia, Label, Room, EmojiEmotions, SettingsRemoteTwoTone, Cancel } from "@mui/icons-material"

export default function Sharepost() {
    const navigate = useNavigate();
    const { showalert, setshowalert, setalertType, user, fetchcurrentuserfun, setalertmessage, scrolltoTopfun } = useContext(SocialContext);
    const PF = "https://socialshub.netlify.app/images/";

    useEffect(() => {
        if (!window.localStorage.getItem('currentUID')) {
            navigate('/');
        }
        window.document.title='SocialHub - Share Post';
    }, []);


    useEffect(() => {
        scrolltoTopfun();
    }, [])

    // for sharePost
    const desc = useRef();
    const [file, setfile] = useState(null);
    const [ret, setret] = useState();


    // --------------------------------------------------------
    const [loading, setloading] = useState(false);
    const handleonchange = (e) => {
        const file = e.target.files[0];
        setfile(file);
        previewFile(file);
    }
    const [priviewsource, setpriviewsource] = useState(null);
    const previewFile = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setpriviewsource(reader.result);
        }
    }
    const submitfun = async (event) => {
        event.preventDefault();
        if (desc.current.value === "" && file == null) {
            setshowalert(true);
            setalertmessage("Please add something and try again");
            setalertType("warning");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
            return;
        }
        uploadimg(priviewsource);
    }
    const uploadimg = async (base64EncodedImage) => {
        const newPost = {
            userId: user._id,
            desc: desc.current.value,
        }
        if (file) {
            newPost.photo = base64EncodedImage;
        }
        try {
            setloading(true);
            const response = await axiosInstance.post(`api/posts/newpost`, newPost);
            setloading(false);
            navigate('/');
        } catch (error) {
            console.log("inside post error", error);
        }
    }







    // -------------------------------------------------------------

    {/*const submitfun = async (event) => {
        event.preventDefault();
        const newPost = {
            userId: user._id,
            desc: desc.current.value,
        }
        if (file) {
            let filename = Date.now() + file.name;

            const data = new FormData();
            data.append('file', file);
            data.append('name', filename);
            try {
                const res = await axiosInstance.post("/api/" + "upload", data);
                newPost.img = res.data.date;
            } catch (error) {
                console.log("inside sharefile error", error);
            }
        }

        try {
            if (desc.current.value === "" && file == null) {
                setshowalert(true);
                setalertmessage("Please add something and try again");
                setalertType("warning");
                setTimeout(() => {
                    setshowalert(false);
                }, 2000);
            } else {
                if (file) {
                    newPost.img += file.name;
                }
                await axiosInstance.post(`/api/posts/newpost`, newPost);
                navigate('/');
            }
        } catch (error) {
            console.log("share ke error me hai ", error);
        }
    }
    const [pic, setpic] = useState('');
    const onChange=()=> {
        // Assuming only image
        setfile(this.refs.file.files[0]);
        var reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {
            setpic(
                [reader.result]
            )
        }.bind(this);
        console.log(url) // Would see a path?
        // TODO: concat files
    }*/}
    
    return (
        <>
            <Topbar />
            {showalert ? <div style={{ 'height': '48px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
                <Alertjs />
            </div> : ""}
            <div className="shareContainer">
                <div className='shareBox'>
                    {loading ? <div style={{ 'minHeight': '100vh', backgroundColor: '#dadada', display: 'flex', 'alignItems': 'center', 'justifyContent': 'center' }}><Progress /></div> : <div className="share sharePost">
                        <h2 style={{ 'textAlign': 'center', color: 'blue' }}>Create New Post</h2>
                        <div className="shareWrapper">
                            <div className="shareTop">
                                <Link style={{ 'textDecoration': 'none' }} to={`/profile/${user._id}`}>
                                    <img className="shareProfileImg" src={user.profilePic ? user.profilePic : PF + "/person/noprofile.jpeg"} alt="" />
                                </Link>
                                <h4>{user.username}</h4>
                            </div>
                            {/* share form */}
                            <form className="shareform" onSubmit={submitfun}>
                                <div className="postInput">
                                    <textarea type="text"
                                        rows={5}
                                        ref={desc}
                                        placeholder={"Write something here..."}
                                    />
                                </div>
                                {file && (<div className="shareImgContainer">
                                    <img src={priviewsource} />
                                    <Cancel className='cancleimg' onClick={() => { setfile(null) }} />
                                </div>)}
                                {!file && (<label htmlFor='file' className='sharePhoto'>
                                    <CollectionsIcon style={{ 'color': 'red', 'marginRight': '5px' }} />
                                    <span>Photos</span>
                                    <input
                                        style={{ display: 'none', cursor: 'pointer' }}
                                        type="file"
                                        name="file"
                                        id="file"
                                        accept='.png,.jpeg,.jpg'
                                        value={file}
                                        onChange={(e) => { handleonchange(e) }}
                                    />
                                </label>)}
                                <button type="submit" className="postButton">POST</button>
                            </form>
                        </div >
                    </div >}
                </div >
            </div >
            <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
                <p style={{ 'textAlign': 'center', opacity: '0.7' }}>Copyright ©2022-Alok.info | All rights reserved</p>
            </div>
            <Bottom />
        </>
    )
}
